'use client'

import {useState} from "react";
import FAQSection from "@/components/Faq/FAQSection";
import {Section} from "@/interface/FAQ";

export default function FaqSearchClient({sections}: { sections: Section[] }) {
    const [query] = useState<string>("");

    const filteredSections = sections.map((section) => ({
        ...section,
        categories: section.categories.map((category) => ({
            ...category,
            faqs: category.faqs.filter(
                (faq) =>
                    faq.question.toLowerCase().includes(query.toLowerCase()) ||
                    faq.answer.toLowerCase().includes(query.toLowerCase())
            ),
        })),
    }));

    return <FAQSection sections={filteredSections}/>;
}
